import { Checkbox, Chip, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import Autocomplete from '@material-ui/lab/Autocomplete'

import * as R from 'ramda'
import React, { FC, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type Props = {
  fieldName: string
  fieldValue: string[]
  rules?: any
  selections: string[]
  limitTags?: number
  disable?: boolean
  noSort?: boolean
  allOptionValue?: string
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const FormMultiAutoCompleteSelector: FC<Record<string, unknown> & Props> = ({
  fieldName,
  fieldValue,
  rules = {},
  selections,
  limitTags,
  disable = false,
  noSort = false,
  allOptionValue
}) => {
  const { control, setValue } = useFormContext()
  const [selectedValues, setSelectedValues] = useState(fieldValue ?? [])

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={rules}
      render={({ ...props }) => (
        <Autocomplete
          {...props}
          multiple
          fullWidth
          disabled={disable}
          limitTags={limitTags ?? 4}
          value={selectedValues}
          defaultValue={[]}
          id={`${fieldName}-multi-auto-complete-selector`}
          options={[
            ...(allOptionValue ? [allOptionValue] : []),
            ...(noSort
              ? selections
              : R.sortBy(R.compose(R.toLower), selections))
          ]}
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          getOptionSelected={(option, value) => {
            return option === value
          }}
          onChange={(_event: React.ChangeEvent<any>, newValue) => {
            if (!R.isNil(allOptionValue)) {
              newValue = R.includes(allOptionValue, newValue)
                ? [allOptionValue]
                : newValue
            }
            setValue(fieldName, newValue)
            setSelectedValues(newValue)
          }}
          renderTags={(values: string[], getTagProps) =>
            (noSort
              ? values
              : R.sortBy(R.compose(R.toLower), values)
            ).map((option: string, index: number) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </>
          )}
          renderInput={(params) => <TextField {...params} />}
        />
      )}
    />
  )
}

export default FormMultiAutoCompleteSelector
